module.exports = __webpack_public_path__ + "static/media/export_folder_demo.4a93af31.png";